"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSWRConfig = exports.getSWRFetcher = exports.HttpV2 = void 0;
const axios_1 = __importDefault(require("axios"));
const Http_1 = require("../api/Http");
exports.HttpV2 = axios_1.default.create({
    baseURL: '/api/v2',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'json',
});
exports.HttpV2.interceptors.request.use((request) => {
    request.headers = request.headers || {};
    request.headers['Auth-Token'] = Http_1.Http.defaults.headers.common['Auth-Token'];
    return request;
});
const getSWRFetcher = (url, params) => {
    return exports.HttpV2.get(url, { params }).then((res) => res.data);
};
exports.getSWRFetcher = getSWRFetcher;
exports.defaultSWRConfig = {
    revalidateOnFocus: false,
};
